var websock = null;
let rec; //断线重连后，延迟重新创建WebSocket连接  rec用来存储延迟请求的代码
let isConnect = false; //连接标识 避免重复连接
let connectCallBack = null;
let messageCallBack = null;
let closeCallBack = null
let pendingAliveResolver = null; // probeConnection 等待心跳回包
let devId = Math.floor(Math.random() * 1000000)

let clearReconnectTimer = () => {
	if (rec) {
		clearTimeout(rec);
		rec = null;
	}
};

let clearHeartbeatTimer = () => {
	if (heartCheck.timeoutObj) {
		clearTimeout(heartCheck.timeoutObj);
		heartCheck.timeoutObj = null;
	}
};

let isConnected = () => {
	return !!(isConnect && websock && websock.readyState === WebSocket.OPEN);
};

/**
 * 静默断开：用于前台恢复时替换可能已僵死的连接，不触发 onClose 回调，避免与主动重连重复
 */
let abortConnection = () => {
	clearReconnectTimer();
	clearHeartbeatTimer();
	isConnect = false;
	if (!websock) {
		return;
	}
	const ws = websock;
	websock = null;
	try {
		ws.onclose = null;
		ws.onerror = null;
		ws.close();
	} catch (e) {
		// ignore
	}
};

let connect = (wsurl, accessToken) => {
	try {
		if (isConnect) {
			return;
		}
		console.log("连接WebSocket");
		websock = new WebSocket(wsurl);
		websock.onmessage = function (e) {
			let sendInfo = JSON.parse(e.data)
			if (sendInfo.cmd == 0) {
				heartCheck.start()
				// 登录成功才算真正完成连接
				connectCallBack && connectCallBack();
				console.log('WebSocket登录成功')
			} else if (sendInfo.cmd == 1) {
				// 重新开启心跳定时
				heartCheck.reset();
				if (pendingAliveResolver) {
					const resolve = pendingAliveResolver;
					pendingAliveResolver = null;
					resolve(true);
				}
			} else {
				// 其他消息转发出去
				console.log("收到消息:", sendInfo);
				messageCallBack && messageCallBack(sendInfo.cmd, sendInfo.data)
			}
		}
		websock.onclose = function (e) {
			console.log('WebSocket连接关闭')
			isConnect = false; //断开后修改标识
			closeCallBack && closeCallBack(e);
		}
		websock.onopen = function () {
			console.log("WebSocket连接成功");
			isConnect = true;
			// 发送登录命令
			let loginInfo = {
				cmd: 0,
				data: {
					accessToken: accessToken,
					devId: devId
				}
			};
			websock.send(JSON.stringify(loginInfo));
		}

		// 连接发生错误的回调方法
		websock.onerror = function (e) {
			console.log('WebSocket连接发生错误:{}', e)
			close(3000);
			isConnect = false;
			closeCallBack && closeCallBack(e);
		}
	} catch (e) {
		console.log("尝试创建连接失败");
		reconnect(wsurl, accessToken); //如果无法连接上webSocket 那么重新连接！可能会因为服务器重新部署，或者短暂断网等导致无法创建连接
	}
};

//定义重连函数（网络异常等场景，保留延迟以避免频繁重连）
let reconnect = (wsurl, accessToken) => {
	console.log("尝试重新连接");
	if (isConnect) {
		//如果已经连上就不在重连了
		return;
	}
	clearReconnectTimer();
	rec = setTimeout(function () {
		connect(wsurl, accessToken);
	}, 15000);
};

// 前台恢复等场景：立即重连，不等待延迟
let reconnectImmediate = (wsurl, accessToken) => {
	console.log("立即重新连接");
	if (isConnect) {
		abortConnection();
	} else {
		clearReconnectTimer();
	}
	connect(wsurl, accessToken);
};

//设置关闭连接
let close = (code) => {
	if (!isConnect) {
		return;
	}
	websock && websock.close(code);
};


//心跳设置
let heartCheck = {
	timeout: 20000, //每段时间发送一次心跳包 这里设置为20s
	timeoutObj: null, //延时发送消息对象（启动心跳新建这个对象，收到消息后重置对象）
	start: function () {
		if (!isConnected()) {
			return;
		}
		console.log('发送WebSocket心跳')
		let heartBeat = {
			cmd: 1,
			data: {}
		};
		try {
			websock.send(JSON.stringify(heartBeat))
		} catch (e) {
			console.log('WebSocket心跳发送失败', e);
		}
	},

	reset: function () {
		clearHeartbeatTimer();
		this.timeoutObj = setTimeout(function () {
			heartCheck.start();
		}, this.timeout);

	}
};

// 页面回到前台时补发心跳并重置定时器
let resetHeartbeat = () => {
	if (!isConnected()) {
		return;
	}
	heartCheck.start();
	heartCheck.reset();
};

/**
 * 探测连接是否真正可用（readyState OPEN 但可能已是僵尸连接）
 * @returns {Promise<boolean>}
 */
let probeConnection = (timeoutMs = 2500) => {
	return new Promise((resolve) => {
		if (!isConnected()) {
			resolve(false);
			return;
		}
		if (pendingAliveResolver) {
			pendingAliveResolver(false);
			pendingAliveResolver = null;
		}
		const timer = setTimeout(() => {
			if (pendingAliveResolver) {
				pendingAliveResolver = null;
				resolve(false);
			}
		}, timeoutMs);
		pendingAliveResolver = (ok) => {
			clearTimeout(timer);
			resolve(!!ok);
		};
		try {
			heartCheck.start();
		} catch (e) {
			clearTimeout(timer);
			pendingAliveResolver = null;
			resolve(false);
		}
	});
};



// 实际调用的方法
let sendMessage = (agentData) => {
	if (websock.readyState === websock.OPEN) {
		// 若是ws开启状态
		websock.send(JSON.stringify(agentData))
	} else if (websock.readyState === websock.CONNECTING) {
		// 若是 正在开启状态，则等待1s后重新调用
		setTimeout(function () {
			sendMessage(agentData)
		}, 1000)
	} else {
		// 若未开启 ，则等待1s后重新调用
		setTimeout(function () {
			sendMessage(agentData)
		}, 1000)
	}
}

let onConnect = (callback) => {
	connectCallBack = callback;
}

let onMessage = (callback) => {
	messageCallBack = callback;
}


let onClose = (callback) => {
	closeCallBack = callback;
}
// 将方法暴露出去
export {
	abortConnection, close, connect, isConnected, onClose, onConnect,
	onMessage, probeConnection, reconnect, reconnectImmediate, resetHeartbeat, sendMessage
};
